export const LOAD = 'ethstats/pendingLastBlock/LOAD';
export const LOAD_SUCCESS = 'ethstats/pendingLastBlock/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/pendingLastBlock/LOAD_FAIL';
